/**
 * OLVATLANNAK JELOLT csatornak - amig a felhasznalo bennuk marad.
 *
 * A csatorna magatol olvasottnak jeloli magat, ha alul allsz (lasd
 * ChannelView, READ_DWELL_MS). Az "olvatlanna jeloles" enelkul egy
 * masodperc alatt semmisse valna: a nezet azonnal visszajelolne. Ezert a
 * jeloles utan az automatikus olvasas szunetel, amig a felhasznalo at nem
 * lep egy masik csatornaba - ahogy a Slackben is.
 */
const held = new Set<string>();

export function holdUnread(channelId: string): void {
  held.add(channelId);
}

export function isUnreadHeld(channelId: string): boolean {
  return held.has(channelId);
}

export function releaseUnreadHold(channelId: string): void {
  held.delete(channelId);
}
